import { utcToZonedTime, format } from 'date-fns-tz';

export const dateComponents = (date) => {
  const dateString = format(date, "yyyy-MM-dd");
  const year = format(date, "yyyy");
  const month = format(date, "MM");
  const day = format(date, "dd");
  return {
    dateString, year, month, day,
  };
};

export const dateString = (date) => date.toLocaleDateString(undefined, {month: "numeric", day: "numeric"});

export const relativeDateString = (date) => {
  const today = new Date();
  const yesterday = new Date();
  const tomorrow = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const dateString = date.toLocaleDateString();
  if (dateString === today.toLocaleDateString()) {
    return "Today";
  } else if (dateString === yesterday.toLocaleDateString()) {
    return "Yesterday";
  } else if (dateString === tomorrow.toLocaleDateString()) {
    return "Tomorrow";
  } else {
    return date.toLocaleDateString(undefined, {month: "numeric", day: "numeric"});
  }
};

export const dayAndTime = (date) => {

  return {
    date: date.toLocaleDateString(),
    day: relativeDateString(date),
    time: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  };

};

export const ZonedDate = (dateString) => {
  const useTZ = true;
  let date;
  let timeZoneShort;
  if (useTZ) {
    const timeZone = "America/New_York";
    date = utcToZonedTime(new Date(dateString), timeZone);
    timeZoneShort = format(date, "zzz", { timeZone });
  } else {
    date = new Date(dateString);
    timeZoneShort = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
  }
  const time = format(date, "h:mm a");
  return {
    date,
    day: relativeDateString(date),
    time,
    timeZoneShort
  };
};
